export enum FieldTypes {
    Text = 1,
    Select,
    Date,
    Range,
    PriceOff,
    OfferLibrary,
    AutoPopulate,
}

export enum OperatorTypes {
    isEqual = 'isEqual',
    isNotEqual = 'isNotEqual',
    isEmpty = 'isEmpty',
    isNotEmpty = 'isNotEmpty',
    In = 'In',
    NotIn = 'NotIn',
}

export interface FormField {
    name: string;
    type: FieldTypes;
    label: string;
    isRequired: boolean;
    isHidden?: boolean;
    tooltip?: string;
    placeholder?: string;
    onChange?: () => void;
    conditions?: FieldCondition;
    isDisabled?: boolean;
    copyValueTo?: string;
    maxCharLimit?: number;
    units?: { unitKey: string; unitArray: { label: string; value: string }[] };
    autoPopulate?: {
        enabled: boolean;
        generateValue?: () => string;
        tooltip?: string;
    };
}

export interface ConditionRule {
    value: string | number | [number, number];
    operator: OperatorTypes;
    field: string;
    fieldType: FieldTypes;
}

export interface Condition {
    conditions: ConditionRule[];
    conjunction: 'any' | 'all'; // "any" means OR, "all" means AND
}

export interface FieldCondition {
    rules: Condition[];
    action: 'isHidden' | 'isDisabled';
}
